import { useEffect, useMemo, useState } from 'react';
import {
  MedicalOption,
  MedicalOptionGroupCode,
  MedicalOptionService
} from '@/modules/surgicalEvent';

export const useMedicalOptions = (groupCode?: MedicalOptionGroupCode) => {
  const [options, setOptions] = useState<MedicalOption[]>([]);

  useEffect(() => {
    if (!groupCode) {
      setOptions([]);
      return;
    }
    MedicalOptionService.getInstance()
      .getGroupOptions(groupCode)
      .then(setOptions)
      .catch((err) => {
        // TODO sentry and handling
        console.log(err);
        return [];
      });
  }, [groupCode]);

  if (!groupCode) {
    return [];
  }

  return options;
};

export const useMedicalOption = (
  optionCode: string | undefined,
  groupCode?: MedicalOptionGroupCode
) => {
  const options = useMedicalOptions(groupCode);

  return useMemo(() => {
    if (!optionCode) {
      return undefined;
    }
    return options?.find((o) => o.code === optionCode);
  }, [optionCode, options]);
};
